import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react'

export const setLoggedUserAction = createAsyncThunk('user/setLoggedUser', async loggedUser => {
  Sentry.setUser({
    id: loggedUser.Username,
    fullName: `${loggedUser.UserAttributes.name || ''} ${loggedUser.UserAttributes.family_name || ''}`,
    email: loggedUser.UserAttributes.email,
  })
  return loggedUser
})

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    loggedUser: {
      UserAttributes: null,
      Username: null,
      groups: [],
      permissions: {
        Admin: false,
        Agent: false,
        OfficeManager: false,
        SeniorAgent: false,
        Worker: false,
      },
    },
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(setLoggedUserAction.fulfilled, (state, { payload }) => {
      state.loggedUser = payload
    })
  },
})

export default userSlice.reducer
